import { useTranslation } from 'react-i18next';
import { PreviewableFile } from '@sib/types';
import {
  NoTableDataProps,
  Button,
  NoTableData as BaseNoTableData,
} from '@sib/ui';
import { Download } from '@sib/ui/icons';
import { downloadFileFromUrl } from '@spendbrain/utils/files';

interface NoTableDataPropsWithFile extends NoTableDataProps {
  file?: PreviewableFile;
}

export const NoTableData = ({ file, ...props }: NoTableDataPropsWithFile) => {
  const { t } = useTranslation();

  const handleDownload = () =>
    file?.fileUrl && downloadFileFromUrl(file.fileUrl, file.name);

  return (
    <BaseNoTableData
      {...props}
      {...(file?.fileUrl && {
        actions: (
          <Button
            onClick={handleDownload}
            className="inline-flex items-center gap-2"
          >
            <Download className="size-4" />
            {t('download.title')}
          </Button>
        ),
      })}
    />
  );
};
